<template>
  <v-card min-width="20vw" align="center" justify="center" outlined>
    <v-card-title>
      <v-list-item>
        <v-list-item-title
          ><h2>{{ $t("title") }}</h2></v-list-item-title
        >
        <v-spacer />
        <v-list-item-action
          ><v-icon class="icon" @click="closeWindow" icon
            >fa-times</v-icon
          ></v-list-item-action
        >
      </v-list-item>
    </v-card-title>
    <v-card-text class="px-7 py-7">
      <p>
        {{ $t("message") }}<br /><b>{{ brokerAccount.identifier }}</b> -
        <b>{{ brokerAccount.broker.name }}</b
        >?
      </p>
      <div class="d-flex align-center justify-center my-7">
        <v-icon class="mr-3" large>fa-exclamation-circle</v-icon>
        <h4 v-html="$t('alert_VerifyBrokerAccount')" />
      </div>
      <v-btn @click="verifyAccount"
        >{{ $t("btnVerify") }}
        <img
          src="@/assets/icons/Audited.svg"
          alt="Audited Icon"
          class="mr-1 centered-img"
          style="width: 16px; height: 16px; color: blue"
      /></v-btn>
    </v-card-text>
  </v-card>
</template>

<script>
import Repository from "../../../repositories/brokerAccount";
export default {
  name: "VerifyBrokerAccount",
  props: {
    brokerAccount: Object,
  },
  methods: {
    verifyAccount() {
      if (this.brokerAccount.automated) {
        Repository.verifyBrokerAccount(this.brokerAccount.id).then(
          (response) => {
            if (response.status < 400 && response) {
              this.brokerAccount.verified = true;
              this.closeWindow();
            }
          }
        );
      }
    },
    closeWindow() {
      this.$emit("closeWindow");
    },
  },
};
</script>



<style scoped></style>
